module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ill"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos1#pho1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Elizabeth Bowes Lyon with her mother (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos2#pho2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Elizabeth, David and Jock Bowes Lyon (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos3#pho3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Elizabeth, aged about five (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos4#pho4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" A letter written by Elizabeth aged six (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos5#pho5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Beryl Poignand in 1915 (By courtesy of Richard Hall)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos6#pho6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" A letter from Elizabeth to Beryl Poignand (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos7#pho7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Jock, May and Rose Bowes Lyon (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos8#pho8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Elizabeth with Prince Paul of Yugoslavia (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos9#pho9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" Elizabeth with Doris Gordon-Lennox, Freddy Dalrymple Hamilton, Bruce Ogilvy, Geordie Haddington, Alix Cavendish and Diamond Hardinge (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos10#pho10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" Prince Albert in 1920 (Photograph by (Mary) Olive Edis © National Portrait Gallery)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos11#pho11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" Elizabeth in 1920 (Photograph by Swaine © Daily Herald Archives/SSPL/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos12#pho12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" At Bisham, Ascot week 1921. (RCIN 2585024.b © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos13#pho13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Elizabeth with Princess Mary and Geordie Haddington (RCIN 2585069 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos14#pho14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Elizabeth at Glamis with her dogs, Peter and Biffin (RCIN 2585078 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos15#pho15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" A house party, September 1921 (RCIN 2585060 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos16#pho16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" The Duke and Duchess of York on the balcony of Buckingham Palace (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos17#pho17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" The bride and groom leaving for their honeymoon (Hulton Archive/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos18#pho18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" The Duchess of York trying her hand at the coconut shy (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos19#pho19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" The Duke and Duchess at the Empire Exhibition, October 1925 (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos20#pho20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" The Duke and Duchess of York (RCIN 2111468 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos21#pho21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" The Duke and Duchess on tour in Australia (RCIN 2940859 © Reserved/The Royal Collection/Simpson, Bell & Co., Coolangatta, Queensland)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos22#pho22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" The Duchess and Lady Strathmore with the Princesses (RCIN 2112235 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos23#pho23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" The Duchess, King George V and Queen Mary with Princess Elizabeth and Princess Margaret (RCIN 2112338 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos24#pho24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" The Duke of York with the Princesses (RCIN 2112417 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos25#pho25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" The Prince of Wales, the Duke of York and the Princesses (RCIN 2112539 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos26#pho26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" The Coronation of King George VI (Hay Wrightson © National Portrait Gallery)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos27#pho27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" A Christmas invitation to Sir Richard Molyneux (RA QEQM-OUT-MOLYNEUX-91)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos28#pho28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The King and Queen on board the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Empress of Australia,")]), _vm._v(" bound for Canada, May 1939 (Evening Standard/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos29#pho29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" The King and Queen in Washington DC with President and Mrs Roosevelt, and the President’s aide, Major-General Edwin Watson, June 1939 (Photo by Hulton Archive/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos30#pho30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" The King and Queen surveying the damage caused by the bombing of Buckingham Palace (RCIN 2941132 © Reserved/The Times)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos31#pho31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" The King and Queen in the gardens of Buckingham Palace, photographed by Cecil Beaton (RCIN 2088561 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos32#pho32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" The King, Queen and the Princesses with General Smuts (RCIN 2704839 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos33#pho33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" The Royal Family on the balcony at Buckingham Palace (Popperfoto/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos34#pho34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Queen Elizabeth II’s Coronation (Photo by Topical Press Agency/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos35#pho35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Queen Elizabeth with the jockey Dick Francis (Photo by Fox Photos/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos36#pho36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" At the controls of a Comet, 1952 (RCIN 25946633 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos37#pho37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" At Saks 5th Avenue (Harry Harris/AP/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos38#pho38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" On tour in Bulawayo (AP/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos39#pho39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" On tour in Canada (RCIN 2599730 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos40#pho40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" With veterans of the Boer War (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos41#pho41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" Attending a reception for the London Scottish Regiment (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos42#pho42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" At a London University Ball (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos43#pho43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" With Prince Charles and John Elphinstone (RCIN 259594344 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos44#pho44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" With the Queen and Princess Margaret (RCIN 2595713 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos45#pho45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" A letter to Sir Frederick Ashton (By courtesy of Anthony Russell-Roberts)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos46#pho46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" Queen Elizabeth with her horse, Special Cargo, which had just won the Whitbread Gold Cup at Sandown Park, April 1984 (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos47#pho47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Queen Elizabeth enjoying a pint of bitter (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos48#pho48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" Queen Elizabeth and her friend Dick Wilkins (RCIN 2324847 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos49#pho49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Queen Elizabeth with her nephew Simon Bowes Lyon and his wife Caroline (RCIN 2599944 © Reserved/The Royal Collection/Studio Neill, Biggleswade)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos50#pho50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" One of Queen Elizabeth’s last public engagements (PA/PA Archive/Press Association Images)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3f3abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 72
// module chunks = 0